import FieldMixins from './mixins/field_mixin.js';
import TextFieldMixin from './mixins/text_field_mixin.js';

const Phone = Vue.extend({
  mixins: [FieldMixins, TextFieldMixin],

  data: function() {
    return {
      type: 'text'
    };
  },

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <Dropdown slot='optionbar'
                :optionGroups='_wrapDropdownOptions(optionbarContent)'
                :initValue='currentOption'
                :optionGroupsFixed='true'
                @change='changeType'>
        <template slot='value-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
        <template slot='option-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
      </Dropdown>
      <template slot='content'>
        <div :class="(editing ? 'edit' : 'display') + '-content'">
          <div class="input-container">
            <input type="number" placeholder='填写文本' readonly />
          </div>
        </div>
      </template>
      <div class="list-group" slot="fill-settings">
        <div class="list-group-name">填写设置</div>
        <div class="list-item clickable"
              @click="toggleUniquenessValidation()">
          <div class="tip">
            <i :class='[ enableUniquenessValidation ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap slp-tooltip right">
            <span>{{_getFillSettingTitle('uniqueness_validation')}}</span>
            <div class="slp-tooltip-content">{{ _getFillSettingTip('uniqueness_validation') }}</div>
            <i class="slp-question-circle"></i>
          </div>
        </div>
      </div>
      <template slot="replaced-settings">
        <slot name="user-settings" :field="field"></slot>
      </template>
    </FieldView>
  `
});

export default Phone;
